import {Image, Skeleton} from 'antd';
import {useEffect, useRef, useState} from 'react';

import {noop} from '../../../../../../../util/function';
import {waitForTime} from '../../../../../../../util/time';

import * as styles from './lazy-image.scss';

type PropsType = {
    src: string;
    alt: string;
};

let queue: Promise<void> = Promise.resolve();

// Загружаем src по очереди (только для irecommend)
// https://bizdata.atlassian.net/browse/FDBK-1484
function enqueueLoad(): Promise<void> {
    const next = queue.then(async () => {
        await waitForTime(2500);
    });

    queue = next;
    return next;
}

export function ReviewLazyImage({src, alt}: PropsType): JSX.Element {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [imageSrc, setImageSrc] = useState<string>('');

    useEffect(() => {
        const element = containerRef.current;

        if (!element || imageSrc) {
            return () => noop;
        }

        let observer: IntersectionObserver | null = null;
        let cancelled = false;

        observer = new IntersectionObserver(([entry]) => {
            if (entry?.isIntersecting && !imageSrc) {
                if (src.includes('irecommend.ru')) {
                    enqueueLoad()
                        .then(() => {
                            if (!cancelled) {
                                setImageSrc(src);
                            }
                        })
                        .catch(console.error);
                } else {
                    setImageSrc(src);
                }

                observer?.disconnect();
            }
        });

        observer.observe(element);

        return () => {
            cancelled = true;
            observer?.disconnect();
        };
    }, [src, imageSrc]);

    return (
        <div className={styles.container} ref={containerRef}>
            {imageSrc ? <Image alt={alt} src={imageSrc} /> : <Skeleton.Image active />}
        </div>
    );
}
